import type WwwBlogPostSummary from '@/types/serializers/Www/BlogPostSummary'

export type BlogCategoryHandle = WwwBlogPostSummary['category_handle']

export interface BlogCategoryOption {
    value: BlogCategoryHandle
    label: string
}

export const BLOG_CATEGORY_OPTIONS: BlogCategoryOption[] = [
    {value: 'guides', label: 'Guides & Tips'},
    {value: 'case-studies', label: 'Case Studies'},
    {value: 'lifestyle', label: 'Lifestyle & Events'},
]

export const BLOG_CATEGORY_LABELS: Record<BlogCategoryHandle, string> =
    Object.fromEntries(BLOG_CATEGORY_OPTIONS.map(option => [option.value, option.label])) as Record<BlogCategoryHandle, string>

/** Route param pattern for /blog/:category — keeps unknown segments falling through to 404. */
export const BLOG_CATEGORY_ROUTE_PATTERN = BLOG_CATEGORY_OPTIONS.map(option => option.value).join('|')
